import { render } from "./InvIcon.vue?vue&type=template&id=454ea42e&scoped=true"
import script from "./InvIcon.vue?vue&type=script&lang=js"
export * from "./InvIcon.vue?vue&type=script&lang=js"

import "./InvIcon.vue?vue&type=style&index=0&id=454ea42e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454ea42e"]])

export default __exports__